import React, { useEffect, useState } from "react"
import AppDialog from "../../../components/Common/AppDialog"

import '../order.css';
import CustomSelect from "../../../components/Form/CustomSelect";
import Helpers from "../../../helpers/helpers";

const RevertOrder = (props) => {
    const [newStatus, setNewStatus] = useState('');
    const [lastStatus, setLastStatus] = useState();

    useEffect(() => {
        if (props?.status) {
            let revertStatus = props?.status === 'shipped' || props?.status === 'ready_for_pickup' ? 'ordered' :
                props?.status === 'delivered' ? 'shipped' : '-';
            setLastStatus(revertStatus);
        }
    }, [props?.status])

    const handleSubmit = () => {
        props.submit(lastStatus);
        // props.close();
    }

    return (
        <AppDialog
            open={props.open}
            close={() => props.close()}
            title={`Revert status to ${Helpers.displayStatusString(lastStatus).toLowerCase()}`}
            titleIcon={'error'}
            positiveTitle={'Revert status'}
            positivePress={() => handleSubmit()}
            positiveButtonStyle={{ backgroundColor: '#ED1A3D', color: 'white', border: '1px solid #ED1A3D' }}
            negativePress={() => props.close()}
            negativeTitle={'Cancel'}
            width={'30%'}
        >
            <div className="mb-3">
                Are you sure you want to revert the status of this order back to {Helpers.displayStatusString(lastStatus)}?
            </div>
            <div className="curve-container p-3" style={{ backgroundColor: '#F9F9F9' }}>
                Notes:
                <ul>
                    {
                        lastStatus === 'ordered' ?
                            <>
                                <li>This action will mark the order as pending shipment and reset any associated shipping details.</li>
                                <li>Any previously entered courier details, tracking number, or tracking URL will be removed.</li>
                            </>
                            : lastStatus === 'shipped' ?
                                <>
                                    <li>This action will mark the order as dispatched and will override the current delivery status.</li>
                                    <li>Any delivery confirmation details will be cleared.</li>
                                    <li>The order will be considered in transit to the customer.</li>
                                </>
                                : <></>
                    }
                </ul>
                {/* <span className="text-bold mx-1">
                    {Helpers.displayStatusString(props?.status)} <i className="ri-arrow-right-line mx-1" /> {Helpers.displayStatusString(lastStatus)}
                </span> */}
            </div>
        </AppDialog>
    )
}

export default RevertOrder;